import owd from 'owd/owd';

export default class ResizeX extends owd.Module {
    constructor(app) {
        super(app);

        this.windowWidth = app.dom.$window[0].innerWidth;

        this.bind();
    }

    bind() {
        this.app.dom.$window.on('resize', (e) => {
            if (this.app.dom.$window[0].innerWidth !== this.windowWidth) {
                this.app.dom.$window.trigger('resize-x');

                this.windowWidth = this.app.dom.$window[0].innerWidth;
            }
        })
    }
}
